import { render, staticRenderFns } from "./AllCars.vue?vue&type=template&id=ba523ea0&"
import script from "./AllCars.vue?vue&type=script&lang=js&"
export * from "./AllCars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports